/** Pure helpers shared by analytics.tsx and its unit tests. */

import type { TFunction } from "i18next";

export function computeAnalyticsHeaderSubtitle(
  hasTaxReturn: boolean,
  lastSavedAt: string | null | undefined,
  t: TFunction,
  locale: string
): string {
  const lastUpdated = lastSavedAt
    ? new Date(lastSavedAt).toLocaleDateString(locale, {
        month: "short", day: "numeric", year: "numeric",
        hour: "numeric", minute: "2-digit",
      })
    : null;
  if (!hasTaxReturn) {
    return t("pages:analytics.headerSubtitleEmpty");
  }
  return lastUpdated
    ? t("pages:analytics.headerSubtitleUpdated", { date: lastUpdated })
    : t("pages:analytics.headerSubtitleBase");
}
